export const adminDrawerWidth = 240;
